'use strict';

const order = {
  template: `
    <h2 class="breadcrumb">
      <small>
        <a href="#/tilbud">Tilbud</a> <i class="fa fa-angle-right"></i>
      </small>
      Ordre
      <small>
        <i class="fa fa-angle-right"></i> <a href="#/ordrebekreftelse">Ordrebekreftelse</a>
      </small>
      <small>
        <i class="fa fa-angle-right"></i> <a href="#/oversikt">Faktura</a>
      </small>
    </h2>

    <p>Det er ingen funksjon for ordre i SendRegning enn&aring;, lenken er bare med for &aring; vise hvordan en typisk fakturaprosess vil se ut i tilfeller der kj&oslash;per sender en formell ordre.</p>

    <p>P&aring; sikt planlegger vi &aring; kunne motta ordre i elektronisk format fra kunder som har innkj&oslash;pssystem som st&oslash;tter det. N&aring;r en kunde mottar en faktura som er basert p&aring; en ordre sendt fra sitt eget system vil det gjør fakturabehandlingen enklere og mer effektiv for kunden, og da får du pengene dine raskere.</p>

    <p>Kontakt oss gjerne p&aring; <a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a> hvis du har innspill eller sp&oslash;rsm&aring;l ang&aring;ende mottak av ordre.</p>
  `
};

angular
  .module('SendRegning')
  .component('order', order)
  .config(($routeProvider) => {
    $routeProvider
      .when('/ordre', {
        title: 'Ordre',
        template: '<order />',
        secure: true
      });
  });
